import { MaterialReactTable, MRT_GlobalFilterTextField, useMaterialReactTable } from 'material-react-table';
import { Box, Button, lighten, Stack } from '@mui/material';
import { RemoveRedEye } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { language_PT_BR } from '@/components/Base/CustomLocales/language_PT_BR.ts';

const TableTermometroRankingOcupacao = ({ 
  type, data, title
}: { type: any, data: any, title: string}) => {
  const navigate = useNavigate();

  const columns = [
    {
      accessorKey: 'name',
      header: title,
      sortDescFirst: true,
      enableMultiSort: true,
      size: 85,
      Cell: ({ renderedCellValue }) => <Box sx={{ml:'20px'}}>{renderedCellValue}</Box>,
    },
    {
      accessorKey: 'score_value',
      header:'',
      size: 35,
      Cell: ({ renderedCellValue }) => (
        <Box
          sx={{
            backgroundColor:
              type === '1' ? 'rgba(206, 250, 206, 1)' : type === '2' ? '#1E1E1E' : '#FCE4D4',
            height: '40px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '5px',
          }}
        >
          {renderedCellValue}
        </Box>
      ),
    },
    {
      accessorKey: 'id',
      header: 'ID',
      enableHiding: true,
      enableSorting: false,
      enableResizing: false,
      size: 0,
    },
  ];

  const tableBasic = useMaterialReactTable({
    columns,
    data,
    localization: language_PT_BR,
    positionActionsColumn: 'last',
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableExpandAll: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enablePagination: false,
    enableRowActions: false,
    enableRowSelection: true,
    enableBottomToolbar: false,
    enableGlobalFilter: false,
    muiPaginationProps: {
      color: 'primary',
      shape: 'rounded',
      showRowsPerPage: false,
      variant: 'outlined',
    },
    initialState: {
      showGlobalFilter: false,
      columnVisibility: {
        id: false,
      },
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
    },
    muiTableHeadCellProps: ({ column }) => {
      return {
        sx: {
          color: 'black',
          fontWeight: 400,
          fontSize: '12px',
          textAlign: column.id === 'mrt-row-select' ? 'center' : 'left',
          padding: column.id === 'mrt-row-select' ? '16px' : undefined,
          width: column.id === 'mrt-row-select' ? '25px' : undefined,

        },
      };
    },
    muiTableBodyCellProps: ({ column }) => {
      return {
        sx: {
          backgroundColor: '#fff',
          color: 'rgba(128, 128, 128, 1)',
          fontWeight: 400,
          fontSize: '12px',
          padding: '0',
          textAlign: column.id === 'mrt-row-select' ? 'center' : 'left',
          width: column.id === 'mrt-row-select' ? '25px' : undefined,
        },
      };
    },
    renderTopToolbar: ({ table }) => {
      const handleDeactivate = () => {
        table.getSelectedRowModel().flatRows.map((row) => {
          alert('deactivating ' + row.getValue('name'));
        });
      };

      const handleActivate = () => {
        table.getSelectedRowModel().flatRows.map((row) => {
          alert('activating ' + row.getValue('name'));
        });
      };

      const handleContact = () => {
        table.getSelectedRowModel().flatRows.map((row) => {
          alert('contact ' + row.getValue('name'));
        });
      };

      return (
        <Box
          sx={(theme) => ({
            backgroundColor: lighten(theme.palette.background.default, 0.05),
            display: 'none',
            gap: '0.5rem',
            p: '8px',
            justifyContent: 'space-between',
            width: '100%'
          })}
        >
          <Box sx={{ borderRadius: '20px' }}>
            <MRT_GlobalFilterTextField table={table} />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                color="error"
                disabled={!tableBasic.getIsSomeRowsSelected()}
                onClick={handleDeactivate}
                variant="contained"
              >
                Deactivate
              </Button>
              <Button
                color="success"
                disabled={!table.getIsSomeRowsSelected()}
                onClick={handleActivate}
                variant="contained"
              >
                Activate
              </Button>
              <Button
                color="info"
                disabled={!table.getIsSomeRowsSelected()}
                onClick={handleContact}
                variant="contained"
              >
                Contact
              </Button>
            </Box>
          </Box>
        </Box>
      );
    },
  });

  return (
    <Box
      sx={{
        maxHeight: '600px',
        overflowY: 'auto',

        border: '1px solid #B3B3B3',
        borderRadius: '5px',

        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555',
        },
      }}
    >
      <MaterialReactTable table={tableBasic} />
    </Box>
  );
};

export default TableTermometroRankingOcupacao;
